import { Model } from "pinia-orm";
import DocumentType from "./DocumentType";
import DocumentStatus from "./DocumentStatus";

export default class Document extends Model {
  static name = "Document";
  static entity = "documents";

  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(),
      createdAt: this.attr(),
      updatedAt: this.attr(),
      relatedObjects: this.attr([]),
      docType: this.attr(),
      docStatus: this.attr(),
      docTypeData: this.belongsTo(DocumentType, "docType"),
      docStatusData: this.belongsTo(DocumentStatus, "docStatus"),
      tags: this.attr(),
      servicesRelatedName: this.attr(),
      originId: this.attr(),
      oldOriginId: this.attr(),
      origin: this.attr(),
      gedProjectId: this.attr(),
      name: this.attr(),
      source: this.attr(),
      ref: this.attr(),
      datetime: this.attr(),
      version: this.attr(),
      metaDatas: this.attr(),
      keyFileUrl: this.string(),
      isActive: this.attr(),
      mimeType: this.attr(),
      generatedBy: this.attr(),
    };
  }
}
